Ext.define('SA.lq.ModelData', {
    constructor({data, derivedState}) {
        this.data = data;
        this.derivedState = derivedState;
    },

    getConditionList() {
        return this.derivedState.conditionList;
    },

    getGeoUnit() {
        return this.derivedState.geoUnit;
    },

    getGeoUnitId() {
        return this.data.geographicUnit;
    },

    getLocationModel() {
        return this.derivedState.locationModel;
    },

    getLocationStringId() {
        return this.derivedState.locationStringId;
    },

    getSortModel() {
        return this.derivedState.sortModel;
    },

    getViewName() {
        return this.data.name;
    },

    hasMaxConditions() {
        return this.derivedState.hasMaxConditions;
    },

    isSavable() {
        return this.derivedState.isSavable;
    },

    unwrap() {
        return this.data;
    }
});